<!--
  UserBubble — a right-aligned user answer. When `editable` (i.e. tied to a step),
  clicking it emits `edit` so the orchestrator can rewind the flow to that step; the
  hover affordance reads `editLabel` and the tooltip `editTitle`. An optional leading
  icon mirrors the choice the bubble echoes.
-->
<template>
  <div class="msg-row user-row">
    <div
      class="bubble user-bubble"
      :class="{ 'user-bubble-editable': editable }"
      :title="editable ? editTitle : undefined"
      :data-edit-label="editable ? editLabel : undefined"
      @click="onClick"
    >
      <img v-if="icon" :src="icon" class="user-bubble-icon" alt="" />
      {{ content }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    content: string
    editable?: boolean
    icon?: string | null
    editTitle?: string
    editLabel?: string
  }>(),
  { editable: false, icon: null, editTitle: 'Cliquez pour modifier cette réponse', editLabel: 'Modifier' },
)

const emit = defineEmits<{ edit: [] }>()

function onClick(): void {
  if (props.editable) emit('edit')
}
</script>

<style scoped>
.msg-row {
  display: flex;
  align-items: flex-end;
  padding: 0 16px;
}
.user-row {
  justify-content: flex-end;
}
.bubble {
  border-radius: 16px;
  padding: 10px 13px;
  font-size: 13.5px;
  line-height: 1.6;
  max-width: 78%;
}
.user-bubble {
  background: var(--navy-800);
  color: var(--white);
  border-bottom-right-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.user-bubble-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
  background: transparent;
}
.user-bubble-editable {
  cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
  position: relative;
}
.user-bubble-editable:hover {
  opacity: 0.82;
}
.user-bubble-editable:hover::after {
  content: '✏️ ' attr(data-edit-label);
  position: absolute;
  right: 0;
  bottom: calc(100% + 4px);
  background: var(--navy-800);
  color: var(--white);
  font-size: 10px;
  padding: 3px 8px;
  border-radius: 6px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0.95;
}
.user-bubble-editable:active {
  transform: scale(0.98);
}
</style>
